export default "/images/Event5.png?c278851b680e4f2ddb419d21b48dbfd4";